import { closeLinkContextMenu } from '../components/LinkContextMenu';
import { SharingLinkInfo, updateSharingLinkFromSharingDialog } from 'owa-link-data';
import { lazyOnLinkHasChanged } from 'owa-recipient-permission-checker';
import { SharingTipRecipientInfo } from 'owa-sharing-data';
import { lazyOpenSharingDialog, SharingDialogResponse } from 'owa-sharing-dialog';

export async function onOpenSharingDialogClicked(
    sharingLink: SharingLinkInfo,
    composeId: string,
    recipientInfos: SharingTipRecipientInfo[]
) {
    closeLinkContextMenu();
    const openSharingDialog = await lazyOpenSharingDialog.import();

    const canonicalUrl = sharingLink.sharingInfo.canonicalUrl;
    const endpointUrl = sharingLink.sharingInfo.siteUrl;
    openSharingDialog(
        endpointUrl,
        canonicalUrl,
        sharingLink.sharingInfo.shareId,
        sharingLink.permissionLevel
    )
        .then((response: SharingDialogResponse) => {
            const linkHasChanged = response.shareId !== sharingLink.sharingInfo.shareId;
            updateSharingLinkFromSharingDialog(sharingLink.linkId, response);

            if (linkHasChanged) {
                lazyOnLinkHasChanged.importAndExecute(
                    sharingLink.linkId,
                    response.permissionLevel,
                    recipientInfos,
                    composeId
                );
            }
        })
        .catch(() => {});
}
